import React, { useEffect, useState } from "react";
import { Button, Row, Col, Input, Form, Modal, Select } from "antd";
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { componentStyles } from "../myProfile/ProfileStyles.js";
import { createFeedback } from "../../pages/feedback/feedbackApi.js";
import { useLocation, useNavigate } from "react-router-dom";
import goBackButton from "../../assets/images/Go_Back.svg";
import { userStrings } from "../../constants/constants";

const Feedback = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [userId, setUserId] = useState('');
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [comment, setComment] = useState("");
  const { Option } = Select;

  useEffect(() => {
    setUserId(localStorage.getItem('userid'));
    setUserEmail(localStorage.getItem('useremail'));
    setUserName(localStorage.getItem('username'));
  }, []);

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const navigateToPreviousPage = () => {
    if (location.state && location.state.from) {
      navigate(location.state.from.pathname + location.state.from.search);
    } else {
      navigate("/landing-page");
    }
  };

  const handleBack = () => {
    navigateToPreviousPage();
  };
  const handleSubjectChange = (value) => {
     if (value === userStrings.CANCEL_SUBSCRIPTION_DELETE_ACCOUNT) {
      form.setFieldsValue({
        comment: "I wish to cancel my subscription to My Friend – Your AI Companion, effective immediately. In accordance with applicable data privacy laws, such as [GDPR/CCPA, if applicable], I also request the permanent deletion of all personal data associated with my account. I understand this may take up to 48 hours to complete.\n\n I understand that by requesting data deletion, my account and its associated information will no longer be recoverable. Should I wish to re-subscribe in the future, I acknowledge that I will need to re-register as a new user.\n\n Please confirm once my account has been cancelled and my data has been fully deleted from your systems.",
      });
    } else if  (value === userStrings.CANCEL_SUBSCRIPTION_RETAIN_ACCOUNT) {
      form.setFieldsValue({
        comment: "I wish to cancel my subscription to My Friend – Your AI Companion, effective immediately. However, I would like my account to be deactivated but request that all associated data be retained \n\n Should I decide to reactivate my account in future, I would like the option to do so with my data intact\n\nPlease confirm once my account has been deactivated.",
      });
    } 
    else {
      form.setFieldsValue({ comment: "" });
    }
  };
   const logoutUser = () => {
    localStorage.removeItem("auth_token");
    navigate("/");
  };

  const handleSubmitFeedback = () => {
    form.validateFields()
      .then(async (values) => {
        const payload = {
          userId,
          userName,
          userEmail,
          comment: values.comment,
          feedbackSubject: values.feedbackSubject,
        };

        // If the user selects "Delete My Data," show confirmation modal
        if (values.feedbackSubject === userStrings.CANCEL_SUBSCRIPTION_DELETE_ACCOUNT) {
          Modal.confirm({
            title: "Confirm!",
            content: "Are you sure you want to cancel subscription and delete your Data?",
            okText: "Confirm",
            okButtonProps: { className: "confirm-button-color" },
            bodyStyle:  { padding: '16px' },
            cancelText: "Cancel",
            onOk: async () => {
              try {
                await createFeedback(payload);
                Modal.success({
                  title: "Subscription Cancel and Delete Data Requested",
                  content: "Your request has been submitted successfully.",
                });
                logoutUser();
                form.resetFields();
              } catch (error) {
                console.error("Error submitting feedback:", error.response ? error.response.data : error.message);
              }
            },
          });
        }
        else if(values.feedbackSubject === userStrings.CANCEL_SUBSCRIPTION_RETAIN_ACCOUNT)  {
          Modal.confirm({
            title: "Confirm!",
            content: "Are you sure you want to cancel subscription and retain your Data?",
            okText: "Confirm",
            okButtonProps: { className: "confirm-button-color" },
            bodyStyle:  { padding: '16px' },
            cancelText: "Cancel",
            onOk: async () => {
              try {
                await createFeedback(payload);
                Modal.success({
                  title: "Subscription Cancel and Retain Data Requested",
                  content: "Your request has been submitted successfully.",
                });
                logoutUser();
                form.resetFields();
              } catch (error) {
                console.error("Error submitting feedback:", error.response ? error.response.data : error.message);
              }
            },
          });  
         
        } else {
          // For other feedback subjects, submit directly
          try {
            await createFeedback(payload);
            Modal.success({
              title: "Feedback Submitted",
              content: "Your feedback has been submitted successfully.",
            });
            navigate("/landing-page");
            form.resetFields();
          } catch (error) {
            console.error("Error submitting feedback:", error.response ? error.response.data : error.message);
          }
        }
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };


  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };

  return (
    <div style={{ minHeight: "100dvh", overflow: "hidden", background: "#fefcfe" }}>
      <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
        <Row justify="space-between" style={{ marginBottom: 20 }}>
          <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
        </Row>
        <button onClick={handleBack} className="text-left pl-4 button-styling setBackButton">
          <img src={goBackButton} alt="Go Back Button" />
        </button>
        <Form form={form}>
          <Row justify="center" style={{ padding: "0px" }}>
            <Col span={16} style={{ paddingLeft: "5%", paddingRight: "5%" }}>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Row style={componentStyles.rowStyling}>
                    <h1 style={{ ...componentStyles.headingStyle, paddingLeft: "80px" }}>Contact Us</h1>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col lg={{ span: 23, offset: 1 }} md={{ span: 23, offset: 2 }} xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }}>
                  <Row style={componentStyles.rowStyle}>
                    <Col span={24}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        name="feedbackSubject"
                        label={<span style={{ ...componentStyles.labelStyle, fontWeight: "bold" }}>Subject</span>}
                        rules={[{ required: true, message: "Please select a subject!" }]}
                      >
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Please Select Subject"
                          onChange={handleSubjectChange}
                        >
                          <Option value="General Enquiry">General Enquiry</Option>
                          <Option value={ userStrings.CANCEL_SUBSCRIPTION_DELETE_ACCOUNT } >Cancel my subscription and Delete my Data</Option>
                          <Option value={userStrings.CANCEL_SUBSCRIPTION_RETAIN_ACCOUNT}>Cancel my subscription and retain my account data</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row style={componentStyles.rowStyle}>
                    <Col span={24}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        name="comment"
                        label={<span style={componentStyles.labelStyle}>Description</span>}
                        rules={[{ required: true, message: "Please enter Description!" }]}
                      >
                        <Input.TextArea
                          style={componentStyles.inputStyle}
                          rows={4}
                          placeholder="Enter Description"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row style={componentStyles.rowStyle}>
                    <Col span={24}>
                      <Button
                        type="submit"
                        onClick={handleSubmitFeedback}
                        style={{ backgroundColor: '#ff4081', color: '#fff' }}
                      >
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Col>
    </div>
  );
};

export default Feedback;
